/** Base64-decodes the JWT payload WITHOUT signature verification. Never use for authorization. */
export function unsafeDecodeJWTPayload<T>(token: string): T | null {
  try {
    const base64Url = token.split('.')[1]; // Get the payload part of the token
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = Buffer.from(base64, 'base64').toString('utf-8');

    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error('Invalid token', e);
    return null;
  }
}
